const body = document.querySelector('body')
const vignettesBlocs = document.querySelectorAll(".bloc-vignettes")
const vignettes = document.querySelectorAll(".js-vignettes")
const panelContentLinks = document.querySelectorAll(".js-vignettesPanel__content a")


// Select all links in panel for tab navigation
panelContentLinks.forEach(panelContentLink => {
    panelContentLink.setAttribute('tabindex', -1)
})


// Add css variables
if (window.innerWidth < 960) {
    vignettes.forEach(vignette => {
        vignette.style.setProperty('--panelTotalHeight', 0)
        vignette.style.setProperty('--panelTotalMargin', 0)
    })
}


// Function open vignettes
function openVignettes(vignette) {

    // Panel
    let panel = vignette.querySelector(".js-vignettesPanel")
    // Panel content
    let panelContent = vignette.querySelector(".js-vignettesPanel__content")
    let panelContentLinks = panelContent.querySelectorAll(".js-vignettesPanel__content a")

    // Variable css --panelPadding
    let panelPadding = parseInt(getComputedStyle(panel).getPropertyValue("--panelPadding"))
    // Variable css --panelTranslate
    let panelMargin = parseInt(getComputedStyle(panel).getPropertyValue("--panelMargin"))
    // Variable css --panelTranslate
    let panelTranslate = parseInt(getComputedStyle(panelContent).getPropertyValue("--panelTranslate"))

    // Height panel
    let panelHeight = (panel.scrollHeight + (2 * panelPadding)) - panelTranslate

    // Function
    vignette.classList.add("js-vignettesActive")

    // if tablet or mobile
    if (window.innerWidth < 960) {
        vignette.style.setProperty('--panelTotalHeight', panelHeight + "px");
        vignette.style.setProperty('--panelTotalMargin', panelHeight + panelMargin + "px");
    } else {
        vignette.style.marginBottom = panelHeight + panelMargin + "px"
        panel.style.height = panelHeight + "px"
    }

    // Select all links in panel for tab navigation
    panelContentLinks.forEach(panelContentLink => {
        panelContentLink.setAttribute('tabindex', 0)
    })

    // Test console.log
    // console.log("Height panel = " + panelHeight)
    // console.log("Variable panelPadding = " + panelPadding)
    // console.log("Variable panelMargin = " + panelMargin)
    // console.log("Variable panelTranslate = " + panelTranslate)
    // console.log("margin-bottom li = " + vignette.style.marginBottom)
}

// Function close vignettes
function closeVignettes(vignette) {

    // Panel
    let panel = vignette.querySelector(".js-vignettesPanel")
    // Panel content
    let panelContent = vignette.querySelector(".js-vignettesPanel__content")
    let panelContentLinks = panelContent.querySelectorAll(".js-vignettesPanel__content a")

    // Function
    vignette.classList.remove("js-vignettesActive")

    if (window.innerWidth < 960) {
        // nothing here
    } else {
        vignette.style.marginBottom = null
        panel.style.height = null
    }

    panelContentLinks.forEach(panelContentLink => {
        panelContentLink.setAttribute('tabindex', -1)
    })
}

// Function position vignettes
function offsetVignettes(el) {
    let rect = el.getBoundingClientRect(),
        scrollTop = window.scrollY || document.documentElement.scrollTop
    return {top: rect.top + scrollTop, left: 0}
}

// Function scroll to top vignette
function scrollToVignette(vignettePositionP) {
    let marginPosition = 10

    if (body.classList.contains("admin-bar")) {
        marginPosition = 42

        if (window.innerWidth < 782) {
            marginPosition = 56
        }
    }

    window.scrollTo({
        top: vignettePositionP - marginPosition,
        left: 0,
        behavior: "smooth",
    })
}


// Action
vignettes.forEach((vignette) => {
    let tab = vignette.querySelector(".js-vignettesTab")

    // On click to vignettes
    tab.addEventListener('click', () => {

        // vignette position
        let vignettePosition = offsetVignettes(vignette)

        // console.log("Position de la vignette cliquée : " + vignettePosition.top)

        function returnpositionTop(vignettePosition) {

            let vignettePositionP = parseInt(vignettePosition.top)
            let parentBloc = tab.closest(".bloc-vignettes")
            let vignetteActive = parentBloc.querySelector(".js-vignettesActive")

            if (vignetteActive) {

                // Height of panel open
                let panel = vignetteActive.querySelector(".js-vignettesPanel")
                let height = panel.offsetHeight
                // console.log("Hauteur du panel actif : " + height)

                // position vs clicked vignette (tab)
                let vignettePositionActive = offsetVignettes(vignetteActive)
                // console.log("Position de la vignette active : " + vignettePositionActive.top)

                // if position above clicked vignette
                if (vignettePositionActive.top < vignettePosition.top) {
                    vignettePositionP -= parseInt(height)
                    // console.log("Scroll vers la bonne position de la vignette : " + vignettePositionP)
                }
            }

            return vignettePositionP
        }

        let vignettePositionP = returnpositionTop(vignettePosition)
        // console.log("vignettePositionP" + vignettePositionP)

        // If vignette open : click on vignette for close
        if (vignette.classList.contains('js-vignettesActive')) {
            // Close vignette
            closeVignettes(vignette)

        } else {
            // Get vignettes only into parent
            let parentVignettes = tab.closest(".bloc-vignettes")
            let vignettes = parentVignettes.querySelectorAll(".js-vignettes")

            // If one vignette open : click on other vignette for close all
            vignettes.forEach((vignette) => {
                closeVignettes(vignette)
            })

            // Open vignettes
            openVignettes(vignette)

            if (window.innerWidth < 960) {
                setTimeout(() => {
                    // Scroll to top vignette
                    scrollToVignette(vignettePositionP)
                }, closeVignettes)
            }

            // console.log("------------------------------------------------------------------- fin de louverture de la vignette")
        }
    })
})

// sources : 
// https://codepen.io/dusanralic/pen/PoqGKLM
// https://developer.mozilla.org/fr/docs/Web/JavaScript/Reference/Global_Objects/parseInt
// https://developer.mozilla.org/fr/docs/Web/API/HTMLElement/offsetHeight
// https://developer.mozilla.org/fr/docs/Web/API/setTimeout
// https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect
